const doc = [({"en":({"js":({"admin":({"photo_sessions":({"nav":({"overview":"Overview"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;